import angular from 'angular';
import component from './social-media-approver.component';

export default angular.module('socialmediaapprover', [
])
	.component('socialmediaapprover', component);
